import { types, getSnapshot } from 'mobx-state-tree'
import TrafficTicket from './TrafficTicket'
import TrafficQuote from './TrafficQuote'

import { TRAFFIC_STATUS } from '~/utilities/constants'


const FetcherTicket = types
  .model('FetcherTicket', {
    ticketID: types.identifier,
    fetcherTrafficTicket: types.maybeNull(TrafficTicket),
    quotes: types.array(TrafficQuote)
  })
  .views(self => ({
    get status() {
      return self.fetcherTrafficTicket.status
    },
    get allQuoteFAQs() {
      if (!self.quotes.length) return []
      return self.quotes.reduce((accum, item) => {
        return accum.concat(item.faq)
      }, [])
    },
    get isFightable() {
      const { fetcherTrafficTicket } = getSnapshot(self)
      if (!fetcherTrafficTicket) return false
      const hasCourt = !!fetcherTrafficTicket.locationCourt
      const hasFightable = typeof fetcherTrafficTicket.fightable === 'boolean'
      // the value "fightable" sent by the back end is not reliable yet. 
      // Until it becomes reliable, the front also requires the ticket to have a court in order to be actually fightable
      const fightable = ( hasFightable ? 
        fetcherTrafficTicket.fightable && fetcherTrafficTicket.status !== TRAFFIC_STATUS.processing : 
        (fetcherTrafficTicket.isPersisted === false ||
        fetcherTrafficTicket.status !== TRAFFIC_STATUS.processing )) && hasCourt 
      return fightable
    },
    get notFightableMessage() {
      if (!self.fetcherTrafficTicket) return 'Ticket is unavailable'
      if (!self.fetcherTrafficTicket.locationCourt) {
        return 'This ticket does not have a court assigned. You can still submit this ticket manually at appwinit.com'
      }
      switch (self.fetcherTrafficTicket.status) {
        case TRAFFIC_STATUS.temp:
        case TRAFFIC_STATUS.pendingQuote:
        case TRAFFIC_STATUS.pendingConf:
          return 'This ticket submission was started but not finished. It is not yet being fought by WinIt.'
        case TRAFFIC_STATUS.processing:
          return 'This ticket is already being fought by WinIt!'
        case TRAFFIC_STATUS.cancelledByUser:
        case TRAFFIC_STATUS.closed:
          return 'This ticket was submitted to WinIt but has been canceled or closed.'
        case TRAFFIC_STATUS.reduced:
          return "This ticket's penalty was reduced by a WinIt attorney."
        case TRAFFIC_STATUS.guilty:
          return 'This ticket was fought by a WinIt attorney and found guilty.'
        case TRAFFIC_STATUS.dismissed:
          return 'This ticket was fought and dismissed by a WinIt attorney.'
        default:
          return 'Sorry, we can not fight this ticket here. Please contact us for more information.'
      }
    }
  }))
  .actions(self => ({}))

export default FetcherTicket
